(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-mewing-reviews-link]').forEach(function (button) {
      if (button.dataset.mewingInit) return;
      button.dataset.mewingInit = 'true';
      button.addEventListener('click', function () {
        var reviews = document.querySelector('.dc-proof');
        if (reviews) reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
